module.exports = __webpack_public_path__ + "img/Q2.8eea8c7b.png";